import React from 'react'

function ViewStudent() {
  return (
    <div>ViewStudent</div>
  )
}

export default ViewStudent